const LOCAL_TWS_API_URL = 'http://localhost:1337'
const DEV_TWS_API_URL = 'https://dev.truweathersolutions.com'
const JOINTDEV_API_URL = 'https://exp.truweathersolutions.com'
const STAGING_TWS_API_URL = 'https://beta.truweathersolutions.com'
const PROD_TWS_API_URL = 'https://api.truweathersolutions.com'

//https was not working on http://3.134.33.108 endpoint so using the prod endpoint
const LOCAL_WMSURL = 'https://wms.truflitev360.com'
const PROD_WMSURL = 'https://wms.truflitev360.com'

const LOCAL_TWS_V2_URL = 'http://localhost:8080'
//If using dev backend on local comment this
const DEV_TWS_V2_URL = 'https://dev-v2.truflitev360.com/'
//If using dev backend on local uncomment this
// const DEV_TWS_V15_URL = 'http://localhost:4200'
const STAGING_TWS_V2_URL = 'https://beta.truflitev360.com/'
const PROD_TWS_V2_URL = 'https://beta.truflitev360.com/'
const JOINTDEV_TWS_V2_URL = 'https://experiment.truflitev360.com/'
const DEV_WDWSTACK = 'truwx-dev'
const PROD_WDWSTACK = 'truwx'
const EXP_WDWSTACK = 'truwx-exp'
export const tempestClientID = '664e5921-1eab-40d6-b123-70b6c279a62e'

const DEV_AUTH0_DOMAIN = 'dev.auth.truweathersolutions.com'
const PROD_AUTH0_DOMAIN = 'auth.truweathersolutions.com'

const DEV_AUTH0_CLIENT_ID = 'lsONGeBd7YvOWoXkRBkPQTNdsqsEeEWa'
const PROD_AUTH0_CLIENT_ID = 'HuVor3hoA7mO91ePhNPw0zMq16THSxlK'

const DEV_AUTH0_AUDIENCE = 'https://dev.truweathersolutions.com'
const PROD_AUTH0_AUDIENCE = 'https://api.truweathersolutions.com'

const DEV_TWS_WS_URL = 'wss://test.truweathersolutions.com/websocket'
const BETA_TWS_WS_URL = 'wss://staging.truweathersolutions.com/websocket'
const PROD_TWS_WS_URL = 'wss://api.truweathersolutions.com/websocket'

export const TWS_API_URL =
  process.env.NODE_ENV === 'dev'
    ? DEV_TWS_API_URL
    : process.env.NODE_ENV === 'joint'
    ? JOINTDEV_API_URL
    : process.env.NODE_ENV === 'staging'
    ? STAGING_TWS_API_URL
    : process.env.NODE_ENV === 'production'
    ? PROD_TWS_API_URL
    : LOCAL_TWS_API_URL

export const WMSURL =
  process.env.NODE_ENV === 'dev'
    ? LOCAL_WMSURL
    : process.env.NODE_ENV === 'joint'
    ? PROD_WMSURL
    : process.env.NODE_ENV === 'staging'
    ? PROD_WMSURL
    : process.env.NODE_ENV === 'production'
    ? PROD_WMSURL
    : LOCAL_WMSURL

export const WDWSTACK =
  process.env.NODE_ENV === 'dev'
    ? EXP_WDWSTACK
    : process.env.NODE_ENV === 'joint'
    ? DEV_WDWSTACK
    : process.env.NODE_ENV === 'staging'
    ? DEV_WDWSTACK
    : process.env.NODE_ENV === 'production'
    ? PROD_WDWSTACK
    : DEV_WDWSTACK

export const TWS_V15_URL =
  process.env.NODE_ENV === 'dev'
    ? DEV_TWS_V2_URL
    : process.env.NODE_ENV === 'staging'
    ? STAGING_TWS_V2_URL
    : process.env.NODE_ENV === 'joint'
    ? JOINTDEV_TWS_V2_URL
    : process.env.NODE_ENV === 'production'
    ? PROD_TWS_V2_URL
    : LOCAL_TWS_V2_URL

export const AUTH0_DOMAIN =
  process.env.NODE_ENV === 'dev'
    ? DEV_AUTH0_DOMAIN
    : process.env.NODE_ENV === 'joint'
    ? DEV_AUTH0_DOMAIN
    : process.env.NODE_ENV === 'staging'
    ? PROD_AUTH0_DOMAIN
    : process.env.NODE_ENV === 'production'
    ? PROD_AUTH0_DOMAIN
    : DEV_AUTH0_DOMAIN

export const AUTH0_CLIENT_ID =
  process.env.NODE_ENV === 'dev'
    ? DEV_AUTH0_CLIENT_ID
    : process.env.NODE_ENV === 'joint'
    ? DEV_AUTH0_CLIENT_ID
    : process.env.NODE_ENV === 'staging'
    ? PROD_AUTH0_CLIENT_ID
    : process.env.NODE_ENV === 'production'
    ? PROD_AUTH0_CLIENT_ID
    : DEV_AUTH0_CLIENT_ID

export const AUTH0_AUDIENCE =
  process.env.NODE_ENV === 'dev'
    ? DEV_AUTH0_AUDIENCE
    : process.env.NODE_ENV === 'joint'
    ? DEV_AUTH0_AUDIENCE
    : process.env.NODE_ENV === 'staging'
    ? PROD_AUTH0_AUDIENCE
    : process.env.NODE_ENV === 'production'
    ? PROD_AUTH0_AUDIENCE
    : DEV_AUTH0_AUDIENCE

export const TWS_WS_URL =
  process.env.NODE_ENV === 'dev'
    ? DEV_TWS_WS_URL
    : process.env.NODE_ENV === 'joint'
    ? DEV_TWS_WS_URL
    : process.env.NODE_ENV === 'staging'
    ? BETA_TWS_WS_URL
    : process.env.NODE_ENV === 'production'
    ? PROD_TWS_WS_URL
    : DEV_TWS_WS_URL
